import VueCookies from 'vue-cookies';

export const delToken = () => {
  VueCookies.remove('auth_token');
};

export const setToken = (token, expire) => {
  VueCookies.set('auth_token', token, new Date(expire), null, null, false, 'Strict');
};

export const getToken = () => {
  const token = VueCookies.get('auth_token');
  if (token) {
    return token;
  }
  return '';
};

export const setNextRoute = (next) => {
  if (next === '') {
    localStorage.setItem('nextRouter', '');
  } else {
    const nextRouter = {};
    nextRouter.path = JSON.parse(JSON.stringify(next.path));
    nextRouter.query = JSON.parse(JSON.stringify(next.query));
    nextRouter.params = JSON.parse(JSON.stringify(next.params));
    localStorage.setItem('nextRouter', JSON.stringify(nextRouter));
  }
};

export const getNextRoute = () => {
  const nextRouter = localStorage.getItem('nextRouter') || '';
  if (nextRouter) return JSON.parse(nextRouter);
  return '';
};

export const localSave = (key, value) => {
  localStorage.setItem(key, value);
};

export const localRead = key => localStorage.getItem(key) || '';

export const localRemove = key => localStorage.removeItem(key);

export const getExt = (key) => {
  const index = key.lastIndexOf('.');
  return key.substr(index);
};

export const getTimestamp = () => Date.parse(new Date()) / 1000;



// WEBPACK FOOTER //
// ./src/utils/util.js